import {useEffect, useState} from "react";
import {BarChart, sampleOptions} from "./components/BarChart"


function mapAnalytics (data) {

    let analyticsArray = []; // this is output array
    // 0 =================================
    if (data !== null) { 
        let analyticsData = data.stock_analytics[0];

        let item = {};
        let percent = +analyticsData.RevenueGrowthPast;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Past Revenue Growth Rate "+percent+"%";           
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Past Revenue Growth Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Past Revenue Growth Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

        // 1 =================================
        item = {};
        percent= +analyticsData.RevenueGrowthCurrent;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Current Revenue Growth Rate "+percent+"%";
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Current Revenue Growth Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {

            item.Percent=percent;
            item.Favourable=0;
            item.Description="Current Revenue Growth Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

        // 2 =================================
        item = {};
        percent= +analyticsData.RevenueGrowthNextYear;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Future Revenue Growth Rate "+percent+"%";
        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Future Revenue Growth Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Future Revenue Growth Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}     

        // 3 =================================
        item = {};
        percent=+analyticsData.EarningsGrowthLastYear;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Past Earnings Growth Rate "+percent+"%";
        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Past Earnings Growth Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Past Earnings Growth Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}
        // 4 =================================
 
        item = {};
        percent=+analyticsData.EarningsGrowthCurrent;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Current Earnings Growth Rate "+percent+"%";
        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Current Earnings Growth Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Current Earnings Growth Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}


        // 5 =================================
        item = {};
        percent=+analyticsData.EarningsGrowthFuture;
        if(percent>=10)
        {

            item.Percent=percent;
            item.Favourable=2;
            item.Description="Future Earnings Growth Rate "+percent+"%";

        }
        else if(percent>=0)//0
        {

            item.Percent=percent;
            item.Favourable=1;
            item.Description="Future Earnings Growth Rate "+percent+"%";

        }
        else if(percent!==-1000)
        {

            item.Percent=percent;
            item.Favourable=0;
            item.Description="Future Earnings Growth Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}      

        // 6 =================================
        item = {};
        percent=+analyticsData.GrossMargin;
        if(percent>=10)
        {

            item.Percent=percent;
            item.Favourable=2;
            item.Description="Gross Margin Rate "+percent+"%";

        }
        else if(percent>=0)//0
        {

            item.Percent=percent;
            item.Favourable=1;
            item.Description="Gross Margin Rate "+percent+"%";

        }
        else if(percent!==-1000)
        {

            item.Percent=percent;
            item.Favourable=0;
            item.Description="Gross Margin Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}    
        // 7 =================================
        item = {};
        percent=+analyticsData.OperatingMargin;
        if(percent>=7)//7.0
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Operating Margin Rate "+percent+"%";

        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Operating Margin Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Operating Margin Rate "+percent+"%";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}     

        // 8 =================================
        item = {};
        percent=+analyticsData.ProfitMargin;
        if(percent>=5)//5.0
        {

            item.Percent=percent;
            item.Favourable=2;
            item.Description="Profit Margin Rate "+percent+"%";

        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Profit Margin Rate "+percent+"%";

        }
        else if(percent!==-1000)
        {

            item.Percent=percent;
            item.Favourable=0;
            item.Description="Profit Margin Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}    

        // 9 =================================
        item = {};
        percent=+analyticsData.ReturnOnEquity;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Return On Equity Rate "+percent+"%";
        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Return On Equity Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Return On Equity Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}            
        
        // 10 =================================
        item = {};
        percent=+analyticsData.ReturnOnCapital;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Return On Capital Rate "+percent+"%";
        }
        else if(percent>=0)//0
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Return On Capital Rate "+percent+"%";
        }
        else if(percent!==-1000)
        { 
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Return On Capital Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}   

        // 11 =================================
        item = {};
        percent=+analyticsData.ReturnOnAssets;
        if(percent>=10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Return On Assets Rate "+percent+"% ";  
        }
        else if(percent>=0)//0
        { 
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Return On Assets Rate "+percent+"%";
        }
        else if(percent!==-1000)
        {
             item.Percent=percent;
            item.Favourable=0;
            item.Description="Return On Assets Rate "+percent+"%";

        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}    

 

        // 12 =================================
        item = {};
        percent=+analyticsData.FyePE;
        if(percent<20)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Price to  Full Year Earnings "+percent+" indicates undervalued.";
        }
        else if(percent<40 && (+analyticsData.EarningsGrowthCurrent)>10)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Price to Full Year Earnings "+percent+" indicates fair value.";
        }
        else
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Price to Full Year Earnings "+percent+" % indicates overvalued.";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}    

        // 13 =================================
        item = {};
        percent=+analyticsData.PEG;
        if(percent<1.5)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Price to Earnings over Growth "+percent+" indicates undervalued.";
        }
        else if(percent<2)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Price to Earnings over Growth "+percent+"  indicates fair value.";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Price to Earnings over Growth "+percent+"  indicates overvalued.";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}   

        // 14 =================================
        item = {};
        percent=+analyticsData.EVEBITDA;
        if(percent<15)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Enterprise Value/EBITDA "+percent+" indicates undervalued.";
        }
        else if(percent<25)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Enterprise Value/EBITDA "+percent+"  indicates fair value.";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Enterprise Value/EBITDA "+percent+"  indicates overvalued.";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}  

        // 15 =================================
        item = {};
        percent=+analyticsData.PS;
        if(percent<3)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Price to Sales "+percent+" indicates undervalued.";
        }
        else if(percent<10)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Price to Sales "+percent+"  indicates fair value.";
        }
        else if(percent!==-1000)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Price to Sales "+percent+"  indicates overvalued.";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}            
        

        // 15 =================================
        const Debt = +analyticsData.Debt;
        const Assets = +analyticsData.Assets;
        const Equity = +analyticsData.Equity;
        const AssetsLastYear = +analyticsData.AssetsLastYear;
        const assetsGrowth = 100 *(Assets-AssetsLastYear)/AssetsLastYear;
        const Liabilities = +analyticsData.Liabilities;
        const LiabilitiesLastYear = +analyticsData.LiabilitiesLastYear;
        const liabilitiesGrowth = 100 *(Liabilities-LiabilitiesLastYear)/LiabilitiesLastYear;
  
        percent = assetsGrowth/liabilitiesGrowth;
        item = {};
        if (assetsGrowth > liabilitiesGrowth)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Assets growth "+Math.round(assetsGrowth)+ "% vs change in liabilites "+Math.round(liabilitiesGrowth)+"%";
            analyticsArray = [...analyticsArray, item]; 
        }
        else
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Assets growth "+Math.round(assetsGrowth)+"% vs change in liabilites "+Math.round(liabilitiesGrowth)+"%";
            analyticsArray = [...analyticsArray, item]; 
        }

        // 16 =================================

        percent = Math.round(100*Debt/Assets);
        item = {};
        if(Debt<=0.5*Assets)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Total Debt is "+percent+"% of Total Assets.";
            analyticsArray = [...analyticsArray, item];  
        }
        else
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Total Debt is "+percent+"% of Total Assets.";
            analyticsArray = [...analyticsArray, item];   
        }

         // 17 =================================
         percent = Math.round(100*Debt/Equity)
         item = {};
         if(Debt<=0.5*Equity)
         {
             item.Percent=percent;
             item.Favourable=2;
             item.Description="Total Debt is "+percent+"% of Total Equity.";
             analyticsArray = [...analyticsArray, item];   
         }
         else
         {
             item.Percent=percent;
             item.Favourable=0;
             item.Description="Total Debt is "+percent+"% of Total Equity.";
             analyticsArray = [...analyticsArray, item];  
         }

        // 18 =================================
        const Cash = +analyticsData.Cash;
        const Interest = +analyticsData.Interest;
        const OpIncome = +analyticsData.OpIncome;
        item = {};
        if(3*Interest<=Cash)
        {
            item.Percent=Interest/Cash;
            item.Favourable=2;
            item.Description="Total Cash "+Math.round(Cash/1000000)+"M is sufficient to pay down Debt.";
            analyticsArray = [...analyticsArray, item]; 
        }
        else
        {
            item.Percent=Interest/Cash;
            item.Favourable=0;
            item.Description="Total Cash "+Math.round(Cash/1000000)+"M is insufficient to pay down Debt.";
            analyticsArray = [...analyticsArray, item]; 
        }
        // 19 =================================
        item = {};
        if(OpIncome*0.35>Interest){
            item.Percent=Interest/OpIncome;
            item.Favourable=2;
            item.Description="Operating Income "+Math.round(OpIncome/1000000)+"M is sufficient to pay Interest.";
            analyticsArray = [...analyticsArray, item]; 
        }
        else
        {
            item.Percent=Interest/OpIncome;
            item.Favourable=0;
            item.Description="Operating Income "+Math.round(OpIncome/1000000)+"M is insufficient compared to Interest paid "+Math.round(Interest/1000000)+"M";
            analyticsArray = [...analyticsArray, item]; 
        }


        // 20 =================================
        percent=+analyticsData.DividentYield;
        item = {};
        if(percent>2)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Divident yield "+percent+"% is favourable.";
            analyticsArray = [...analyticsArray, item]; 
        }
        else if(percent>0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Divident yield "+percent+"% is positive.";
            analyticsArray = [...analyticsArray, item]; 
        }
        else
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="No dividend issued.";
            analyticsArray = [...analyticsArray, item]; 
        }
    }
    return (analyticsArray);
}

function mapFinancials (data) {

    let financialData = {revenue:[], earnings:[], eps:[], grossMargin:[], operatingMargin:[], netMargin:[], assets:[], liabilities:[],debt:[], cash:[], reported:[]};

    if (data !== null) { 

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.reported[idx] = item.ReportPeriod ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.revenue[idx] = item.Revenue/1000000 ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.earnings[idx] = item.Earnigns/1000000 ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.eps[idx] = item.EPS))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.grossMargin[idx] = 100*item.GrossMargin ))

        data.stock_annual_financials.map((item, idx)=> ( 
                financialData.operatingMargin[idx] = 100*item.OperatingMargin ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.netMargin[idx] = 100*item.ProfitMargin ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.assets[idx] = item.Assets/1000000 ))
        
        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.liabilities[idx] = item.Liabilities/1000000 ))

        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.cash[idx] = item.Cash/1000000 ))
        
        data.stock_annual_financials.map((item, idx)=> ( 
            financialData.debt[idx] = item.Debt/1000000 ))

    }
    return financialData;
}





function setIncomeChart (financials) {
    let iData = {};

    if (financials ) {
      iData = {
        labels: financials.reported,
        datasets: [{
           label: 'Revenue',
           data: financials.revenue,
           backgroundColor: 'rgba(53, 162, 235, 0.7)',
        },
        {
           label: 'Earnings',
           data: financials.earnings,
           backgroundColor: 'rgba(53, 235, 162, 0.7)',
        }]
      };
  
    }
    return iData;
  };

  function setMarginChart (financials) {
    let iData = {};
  
    if (financials ) {
      iData = {
        labels: financials.reported,
        datasets: [{
           label: 'Gross',
           data: financials.grossMargin,
           backgroundColor: 'rgba(53, 162, 235, 0.7)',
        },
        {
           label: 'Net',
           data: financials.netMargin,
           backgroundColor: 'rgba(53, 235, 162, 0.7)',
        }]
      };
  
    }
    return iData;
  };
  

function setAssetsChart (financials) {
    let iData = {};

    if (financials ) {
      iData = {
        labels: financials.reported,
        datasets: [{
           label: 'Assets',
           data: financials.assets,
           backgroundColor: 'rgba(53, 235, 162, 0.7)',
        },
        {
           label: 'Liabilities',
           data: financials.liabilities,
           backgroundColor: 'rgba(255, 235, 99, 0.8)',
        }]
      };
  
    }
    return iData;
  };

  function setDebtChart (financials) {
    let iData = {};

    if (financials ) {
      iData = {
        labels: financials.reported,
        datasets: [{
            label: 'Cash',
            data: financials.cash,
            backgroundColor: 'rgba(53, 235, 162, 0.7)',
        },
        {
           label: 'Debt',
           data: financials.debt,
           backgroundColor: 'rgba(255, 99, 132, 0.7)',
        }]

      };
  
    }
    return iData;
  };

function Analytics (props) {

    const [analytics, setAnalytics] = useState([]);
    const [financials, setFinancials] = useState(null);

    const ticker = props.ticker;
  
    function fetchFinancials(url)  {
    
        const abortCtrl   = new AbortController();
    
        const fetchData= async () => {
              console.log("fetch financials... "); 
              try {
                  const response = await fetch(url,{signal: abortCtrl.signal});
                  const json = await response.json();
                  setFinancials(mapFinancials(json));
                  console.log("fetch financials done");  
              } catch (error) {
                  if (error.name === 'AbortError'){
                      console.log("aborted", error);
                  }
                  else {
                      console.log("error", error);
                  }
              }
        };
      
        fetchData();
      
        return () => abortCtrl.abort();
      }

      function fetchAnalytics(url)  {
    
        const abortCtrl   = new AbortController();
    
        const fetchData= async () => {
              console.log("fetch analytics... "); 
              try {
                  const response = await fetch(url,{signal: abortCtrl.signal});
                  const json = await response.json();
                  setAnalytics(mapAnalytics(json));
                  console.log("fetch analytics done");  
              } catch (error) {
                  if (error.name === 'AbortError'){
                      console.log("aborted", error);
                  }
                  else {
                      console.log("error", error);
                  }
              }
        };
      
        fetchData();
      
        return () => abortCtrl.abort();
      }

      useEffect(() => {
        const server = "https://app.cuetraders.com/api/";

        let url = server + "get_annual_financials.php?ticker=" + ticker ;
        fetchFinancials(url);
    
        url = server +  "get_stock_analytics.php?ticker=" + ticker ;
        fetchAnalytics(url);
    
      }, [ticker]);

      return (<div className="Analytics"> {financials && <div>
      <div className="col-lg-12 col-sm-12 col-xs-12">
           <h4>Revenue and Earnings</h4>
           <BarChart chartData={setIncomeChart(financials)} chartOptions={sampleOptions}></BarChart>
           {analytics[3] && <div>
           <ul className="list-style-type:disc">
              <li> {(analytics[0].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[0].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[0].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[0].Description}</i></li>
              <li> {(analytics[1].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[1].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[1].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[1].Description}</i></li>
              <li> {(analytics[2].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[2].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[2].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[2].Description}</i></li>
              <li> {(analytics[3].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[3].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[3].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[3].Description}</i></li>
            </ul>
           </div>}
        </div>

        <div className="col-lg-12 col-sm-12 col-xs-112">
          <h4>Profits Margins</h4>
          <BarChart chartData={setMarginChart(financials)} chartOptions={sampleOptions}></BarChart>
          {analytics[8] && <div>
          <ul className="list-style-type:disc">
            <li> {(analytics[5].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[5].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[5].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[5].Description}</i></li>
            <li> {(analytics[6].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[6].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[6].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[6].Description}</i></li>
            <li> {(analytics[7].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[7].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[7].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[7].Description}</i></li>
            <li> {(analytics[8].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[8].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[8].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[8].Description}</i></li>
            <li> {(analytics[9].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[9].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[9].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[9].Description}</i></li>
           </ul>
          </div>}
        </div>

        <div className="col-lg-12 col-sm-12 col-xs-12">
          <h4>Assets and Liabilities</h4>
          <BarChart chartData={setAssetsChart(financials)} chartOptions={sampleOptions}></BarChart>
          {analytics[15] && <div>
          <ul className="list-style-type:disc">
            <li> {(analytics[10].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[10].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[10].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[10].Description}</i></li>
            <li> {(analytics[15].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[15].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[15].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[15].Description}</i></li>
             </ul>
          </div>}
        </div>     


        <div className="col-lg-12 col-sm-12 col-xs-12">
          <h4>Cash and Debt</h4>
          <BarChart chartData={setDebtChart(financials)} chartOptions={sampleOptions}></BarChart>
          {analytics[18] && <div>
          <ul className="list-style-type:disc">
            <li> {(analytics[16].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[16].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[16].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[16].Description}</i></li>
            <li> {(analytics[17].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[17].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[17].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[17].Description}</i></li>
            <li> {(analytics[18].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[18].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[18].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[18].Description}</i></li> 
           </ul>
        </div>}</div>
        </div>}
        </div>)
};

export default Analytics;